/**
 * Opens a player's page from a name drawn on the Pitch (SE-8605).
 *
 * The Table view's name cell opens the player page; the Pitch drew the same
 * names as plain text. The names live three molecules deep (field card line,
 * card ● squad line, Unassigned row), under both the watchlist Pitch and the
 * scenario Pitch, so the organism that knows where "back" leads publishes the
 * navigator here instead of threading it through every layer in between.
 *
 * No provider (a gallery, an isolated test) = null, and the names render as
 * plain text exactly as before.
 * @module features/scouting/contexts/PitchPlayerNavigationContext
 */
import { createContext } from "react";

/** Opens the player page for one player the Pitch names. */
export type OpenPitchPlayer = (playerId: string, displayName: string) => void;

/** The Pitch's player navigator, or null where names are not links. */
export const PitchPlayerNavigationContext =
  createContext<OpenPitchPlayer | null>(null);
